<h2 class="text-xl font-bold mb-4">Verknüpfung korrekt</h2>

<div class="mb-6">
  <h3 class="text-lg font-semibold text-green-600 flex items-center mb-2">
    <span class="mr-2">✅</span> Akzeptieren, wenn:
  </h3>
  <ul class="list-disc ml-6 space-y-2">
    <li>
      Die angegebenen Verknüpfungen zu anderen Formularen oder Dokumenten
      korrekt und funktional sind.
    </li>
    <li>Alle Links funktionieren und auf die richtigen Inhalte verweisen.</li>
  </ul>
</div>

<div class="mb-6">
  <h3 class="text-lg font-semibold text-red-600 flex items-center mb-2">
    <span class="mr-2">❌</span> Ablehnen bzw. Änderung erforderlich, wenn:
  </h3>
  <ul class="list-disc ml-6 space-y-2">
    <li>Die Verknüpfung fehlerhaft oder irreführend ist.</li>
    <li>Falsche oder veraltete Formulare verknüpft wurden.</li>
    <li>Die Verknüpfung nicht logisch oder hilfreich für den Nutzer ist.</li>
  </ul>
</div>

<div class="mt-4 p-4 bg-blue-50 rounded-lg">
  <p class="flex items-center text-blue-800">
    <span class="mr-2">➡</span>
    <span class="font-semibold">Best Practice:</span>
    Falls eine Verknüpfung fehlerhaft ist, sollte eine Begründung angegeben und
    der Antragsteller aufgefordert werden, die Korrektur vorzunehmen.
  </p>
</div>
